import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService } from '../../services/shared-data.service';
import { CpMarketplaceApiService } from '../../services/cp-marketplace-api.service';
import { CpAuthenticationService } from '../../services/cp-authentication.service';
import { ToastrService } from 'ngx-toastr';

class SetPasswordDetails {
  username: string;
  password: string;
  confirmPassword: string;
}


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

/**
 * This is the Top Level component in the login flow which uses if conditions to show and hide other login flow components.
 */
export class LoginComponent implements OnInit {
  loginType: string = null;
  loginConfig: string = null;
  loginParams: any;
  error: any;
  loading: any;
  returnUrl: any;
  isBoxUp = false;

  constructor(
    private apiService: CpMarketplaceApiService,
    private authenticationService: CpAuthenticationService,
    private toastr: ToastrService,
    private sharedData: SharedDataService,
    private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loginType = params.loginType || null;
      this.loginParams = params;
      if (this.loginType === null) {
        if (this.sharedData.getUserDataFromLS() && this.sharedData.getUserDataFromLS().user_id) {
          this.authenticationService.performRedirect();
        }
      }
    });
  }

  toggleCollapse() {
    this.isBoxUp = !this.isBoxUp;
  }

}
